import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductFilterPipe } from './Services/product-filter.pipe';
import { ExcelService } from './Services/ExcelService .service';
import { SeasonalityFilterPipe } from './Services/Seasonality-Filter.pipe';
import { BannerFilterPipe } from './Services/Banner-filter.pipe';
import { CogsFilterPipe } from './Services/Cogs-filter.pipe';
import { SellInContractFilterPipe } from './Services/SellInContract-filter.pipe';
import { EposFilterPipe } from './Services/Epos-filter.pipe';
import { ShopperFilterPipe } from './Services/Shopper-filter.pipe';
import { PromoQualificationFilterPipe } from './Services/PromoQualification-filter.pipe';
import { PromoFilterPipe } from './Services/Promo-Filter.Pipe';
import { DailyRosFilterPipe } from './Services/DailyRos-Filter.Pipe';
import { VatFilterPipe } from './Services/Vat-filter.pipe';
import { DutiesFilterPipe } from './Services/Duties-filter.pipe';
import { PromoFundindRangeFilterPipe } from './Services/CustomSegment-filter.pipe';
import { HandlingFilterPipe } from './Services/Handlings-filter.pipe';
import { PromotedVolumeFilterPipe } from './Services/PromotedVolume-filter.pipe';
import { EposFirstDayFilterPipe } from './Services/EposFirstDay-filter.pipe';
import { GenericService } from './Services/generic.service';
import { PromoMultipleFilterPipe } from './Services/Promo-Multiple-filter.pipe';
import { PromoDepthFilterPipe } from './Services/PromoDepth-filter.pipe';
import { LoginComponent } from './login/login.component';

import { SeasonalityCategoryFilterPipe } from './Services/SeasonnalityCategory-filter.pipe';
import { MultipleFilterPipe } from './Services/MutipleApi-Filter.pipe';
import { PagerService } from './Services/pager.service';
import { LoginVistaComponent } from './LoginAuth/LoginVista.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as adal from 'adal-angular6';
import { AuthentificationServiceAD } from './auth/authentificationAd.service';
import { SettingFilterService } from './Services/setting-filter.service';
import { CustomersFilterService } from './Services/customers-filter.service';
import { BrandsFilterService } from './Services/brands-filter.service';
import { DatePipe } from '@angular/common';

// or
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

//session
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup

//cookies
import { CookieModule } from 'ngx-cookie';


import { DigitOnlyModule } from '@uiowa/digit-only';
import { SharedModule } from './modules/shared/shared.module';
import { AuthenticationService } from './auth/authentication.service';
import { AccessRightService } from './auth/access-right.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from './Services/config.service';


export function initConfig(configService: ConfigService) {
  return () => configService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    //filter
    ProductFilterPipe,
    // OrderByPipe,
    MultipleFilterPipe,
    SeasonalityFilterPipe,
    BannerFilterPipe,
    CogsFilterPipe,
    SellInContractFilterPipe,
    EposFilterPipe,
    PromoFilterPipe,
    PromoQualificationFilterPipe,
    ShopperFilterPipe,
    DailyRosFilterPipe,
    VatFilterPipe,
    DutiesFilterPipe,
    EposFirstDayFilterPipe,
    PromotedVolumeFilterPipe,
    HandlingFilterPipe,
    PromoFundindRangeFilterPipe,
    PromoMultipleFilterPipe,
    PromoDepthFilterPipe,
    SeasonalityCategoryFilterPipe,
    SettingFilterService,
    CustomersFilterService,
    BrandsFilterService,
    //ORganisation
    LoginComponent,
    LoginVistaComponent,
    //Shared
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA], imports: [BrowserModule,
    RouterModule.forRoot([]),
    DigitOnlyModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
    }),
    CookieModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    SharedModule,
    //NgBusyModule,
    NgbModule],
  providers: [
    DatePipe,
    ExcelService,
    GenericService,
    PagerService,
    AuthentificationServiceAD,
    AuthenticationService,
    AccessRightService,
    adal.Adal6Service,
    {
      provide: adal.Adal6HTTPService,
      useFactory: adal.Adal6HTTPService.factory,
      deps: [HttpClient, adal.Adal6Service]
    },
    {
      provide: APP_BASE_HREF, useValue: '/'
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
